import angular from 'angular';
import onboardingQuestionnaire from './onboardingQuestionnaire';

export default angular
  .module('components.onboardingQuestionnaire', [])
  .component('onboardingQuestionnaire', onboardingQuestionnaire).name;
